import { DeviceBatchState, RootState, DeviceBatch } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import DeviceService from '@/services/device.service';
import * as papaparse from 'papaparse';
import store from '../store';

type DeviceGetter = GetterTree<DeviceBatchState, RootState>;

export const initialState = (): DeviceBatchState => {
  return {
    initialState,
    activeBatch: {
      id: Math.random().toString(36).substring(7),
      device_version_id: 0,
      device_ids: [],
      project_id: 0,
      group_id: 0,
      group_name: '',
      bearer: '',
      managedByDaizy: true,
    },
  };
};

export const getters: DeviceGetter = {
    activeBatch: (state) => state.activeBatch,
};

export const mutations: MutationTree<DeviceBatchState> = {
  updateActiveBatch(state, activeBatch) {
    state.activeBatch = activeBatch;
  },
  updateActiveBatchRemove(state) {
    state.activeBatch = initialState().activeBatch;
  },
  updateActiveBatchDeviceVersionId(state, deviceVersionId) {
    state.activeBatch.device_version_id = deviceVersionId;
  },
  updateActiveBatchBearer(state, bearer) {
    state.activeBatch.bearer = bearer;
  },
  updateActiveBatchRemoveDeviceId(state, row) {
    state.activeBatch.device_ids = state.activeBatch.device_ids.filter((item: any) => item.device_id !== row.device_id);
  },
  updateActiveBatchAddDeviceId(state, row) {
    state.activeBatch.device_ids.push(row);
  },
  updateActiveBatchAddDeviceIds(state, rows) {
    state.activeBatch.device_ids = state.activeBatch.device_ids.concat(rows);
  },
  updateActiveBatchRemoveDeviceIds(state) {
    state.activeBatch.device_ids = [];
  },
  updateActiveBatchProjectId(state, projectId) {
    state.activeBatch.project_id = Number(projectId);
  },
  updateActiveBatchGroupId(state, groupId) {
    state.activeBatch.group_id = Number(groupId);
  },
  updateActiveBatchGroupName(state, groupName) {
    state.activeBatch.group_name = groupName;
  },
};

export const actions: ActionTree<DeviceBatchState, RootState> = {
  async saveDevicesAsync(context: any, activeOrganisationId: number) {
    const activeBatch: any = context.state.activeBatch;
    const dataToPost: any[] = activeBatch.device_ids.map((device: any) => {
      return {
        pac: device.device_pac,
        app_key: device.app_key,
        managed_by_daizy: device.managed_by_daizy,
        network_id: device.device_id,
        device_id: device.custom_id,
        device_version_id: activeBatch.device_version_id,
        group_id: activeBatch.group_id > 0 ? activeBatch.group_id : null,
        group_name: activeBatch.group_name !== '' ? activeBatch.group_name : null,
        organisation_id: activeOrganisationId,
        project_id: activeBatch.project_id > 0 ? activeBatch.project_id : null,
      };
    });
    const response = await DeviceService.saveDevices(dataToPost, activeBatch.device_version_id);
    return true;
  },
  async processCsvFileAsync(context: any, file: any) {
    store.commit('addNetwork', { loading: true });
    return new Promise<any>((resolve, reject) => {
      const rows: object[] = [];
      papaparse.parse(file.files[0], {
        worker: true,
        header: true,
        skipEmptyLines: true,
        step: ((row: any) => rows.push(row.data)),
        complete: () => {
          store.commit('addNetwork', { loading: false });
          return resolve(rows);
        },
        error: (error: papaparse.ParseError) => {
          store.commit('addNetwork', { loading: false });
          return reject(error);
        },
      });
    });
  },
};

export const batches: Module<DeviceBatchState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
